import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { Color } from 'ng2-charts';
@Component({
  selector: 'app-discussion-channel',
  templateUrl: './discussion-channel.component.html',
  styleUrls: ['./discussion-channel.component.scss']
})
export class ChannelDiscussion implements OnInit {

  @Input() dataReport: any
  title_report = 'Kênh thảo luận';


  public doughnutChartOptions: any = {
    plugins: {
      labels: {
        render: 'percentage',
        fontColor: 'black',
        position: 'outside',
        precision: 0,
        arc: true,
        fontSize: 10,
        textMargin: 4,
        fontStyle: 'bold'
      }
    }
  }
  public doughnutChartType = 'doughnut';
  public doughnutChartColors: Color[] = [
    { backgroundColor: ["#0071c1", "#ffc001",'red','aqua','brown','cadetblue'] }
  ];
  public doughnutChartLabels = ['Facebook', 'News','Youtube','Tiktok','Instagram','Linkedin'];
  public doughnutChartData = [
    [30,40]
  ];
  tong_thao_luan = 0;

  htmlFacebook = '';
  htmlNews = '';

  widthPosFacebook :any =  '10%';
  widthNegFacebook :any = '20%';
  widthNeuFacebook :any = '70%';

  widthPosNews:any =  '10%';
  widthNegNews :any = '20%';
  widthNeuNews :any = '70%';

  widthPosYoutube:any =  '10%';
  widthNegYoutube :any = '20%';
  widthNeuYoutube :any = '70%';

  widthPosTiktok:any =  '10%';
  widthNegTiktok :any = '20%';
  widthNeuTiktok :any = '70%';

  widthPosInstagram:any =  '10%';
  widthNegInstagram :any = '20%';
  widthNeuInstagram :any = '70%';

  widthPosLinkedin:any =  '10%';
  widthNegLinkedin :any = '20%';
  widthNeuLinkedin :any = '70%';

  constructor() {
    console.log(this.dataReport)
  }

  ngOnInit(): void {
  };
  ngOnChanges(changes: SimpleChanges) {
    console.log(this.dataReport)
    this.mappingData()
    // changes.prop contains the old and the new value...
  }
  mappingData() {
    if(this.dataReport && this.dataReport.data) {
      if(this.dataReport.report_title) {
        this.title_report = this.dataReport.report_title;
      }
      let sentimentFacebook = this.dataReport.data.sentimentFacebook || {};
      let sentimentNews = this.dataReport.data.sentimentNews || {};

      let sentimentYoutube = this.dataReport.data.sentimentYoutube || {};
      let sentimentTiktok = this.dataReport.data.sentimentTiktok || {};
      let sentimentInstagram = this.dataReport.data.sentimentInstagram || {};
      let sentimentLinkedin = this.dataReport.data.sentimentLinkedin || {};
      
      this.doughnutChartData = [
        this.dataReport.data.facebookCount,
        this.dataReport.data.newCount,
        this.dataReport.data.youtubeCount,
        this.dataReport.data.tiktokCount,
        this.dataReport.data.instagramCount,
        this.dataReport.data.linkedinCount
      
      ]
      this.tong_thao_luan = this.dataReport.data.facebookCount + this.dataReport.data.newCount + this.dataReport.data.linkedinCount +this.dataReport.data.youtubeCount+this.dataReport.data.tiktokCount+this.dataReport.data.instagramCount;

      this.widthNegFacebook = ((sentimentFacebook['neg'] || 0)/this.dataReport.data.totalSentimentFacebook *100).toFixed(2) + '%';
      this.widthNeuFacebook = ((sentimentFacebook['neu'] || 0)/this.dataReport.data.totalSentimentFacebook *100).toFixed(2) + '%';
      this.widthPosFacebook = ((sentimentFacebook['pos'] || 0)/this.dataReport.data.totalSentimentFacebook *100).toFixed(2) + '%';

      this.widthNegNews = ((sentimentNews['neg'] || 0)/this.dataReport.data.totalSentimentNews *100).toFixed(2) + '%';
      this.widthNeuNews = ((sentimentNews['neu'] || 0)/this.dataReport.data.totalSentimentNews *100).toFixed(2) + '%';
      this.widthPosNews = ((sentimentNews['pos'] || 0)/this.dataReport.data.totalSentimentNews *100).toFixed(2) + '%';

      this.widthNegYoutube = (((sentimentYoutube['neg'] || 0)/this.dataReport.data.totalSentimentYoutube *100)|| 0).toFixed(2) + '%';
      this.widthNeuYoutube = (((sentimentYoutube['neu'] || 0)/this.dataReport.data.totalSentimentYoutube *100)|| 0).toFixed(2) + '%';
      this.widthPosYoutube= (((sentimentYoutube['pos'] || 0)/this.dataReport.data.totalSentimentYoutube *100)|| 0).toFixed(2) + '%';

      this.widthNegTiktok = (((sentimentTiktok['neg'] || 0)/this.dataReport.data.totalSentimentTiktok *100)|| 0).toFixed(2) + '%';
      this.widthNeuTiktok = (((sentimentTiktok['neu'] || 0)/this.dataReport.data.totalSentimentTiktok *100)|| 0).toFixed(2) + '%';
      this.widthPosTiktok = (((sentimentTiktok['pos'] || 0)/this.dataReport.data.totalSentimentTiktok *100)|| 0).toFixed(2) + '%';

      this.widthNegInstagram = (((sentimentInstagram['neg'] || 0)/this.dataReport.data.totalSentimentInstagram *100)|| 0).toFixed(2) + '%';
      this.widthNeuInstagram = (((sentimentInstagram['neu'] || 0)/this.dataReport.data.totalSentimentInstagram *100)|| 0).toFixed(2) + '%';
      this.widthPosInstagram = (((sentimentInstagram['pos'] || 0)/this.dataReport.data.totalSentimentInstagram *100)|| 0).toFixed(2) + '%';

      this.widthNegLinkedin =( ((sentimentLinkedin['neg'] || 0)/this.dataReport.data.totalSentimentLinkedin *100) || 0).toFixed(2)  + '%';
      this.widthNeuLinkedin =( ((sentimentLinkedin['neu'] || 0)/this.dataReport.data.totalSentimentLinkedin *100)|| 0).toFixed(2)   + '%';
      this.widthPosLinkedin =( ((sentimentLinkedin['pos'] || 0)/this.dataReport.data.totalSentimentLinkedin *100)|| 0).toFixed(2)  + '%';
      this.htmlFacebook = this.dataReport.data.htmlFacebook;
      this.htmlNews = this.dataReport.data.htmlNews;
 
    }
  }
}



// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/discussion-channel/discussion-channel.component.ts